ioi_partners.ProductSearch = class {
	constructor(opts) {
		/* Options: search_box_id (for custom search box) */
		$.extend(this, opts);
		this.search_box_id = this.search_box_id || "#search-box";
		this.searchBox = $(this.search_box_id);

		this.forgetRecentSearches();
		this.bindSearchAction();
		this.restoreSearchFromRoute();
	}

	// The search box used to keep a "Recent" history in localStorage. It is gone;
	// drop what it left in the browser rather than keep past search terms around.
	// try/catch: storage access can throw (private mode, blocked site data).
	forgetRecentSearches() {
		try {
			localStorage.removeItem("recent_searches");
		} catch (e) {
			// nothing to clean up
		}
	}

	// Show the term the listing was filtered by when it came from ?search=, so the
	// results do not look narrowed for no visible reason - and so the visitor has
	// the ordinary control for clearing it.
	//
	// Runs in the constructor because prepare_search() (views.js) rebuilds
	// #search-box on every make(), i.e. on every family click. That is also what
	// makes this self-clearing: change_route_with_filters() writes only start,
	// field_filters and attribute_filters, so the first filter click drops search
	// from the URL and the rebuilt box comes back empty.
	restoreSearchFromRoute() {
		const params = frappe.utils.get_query_params();

		// A ?product= link wins over ?search= (api.py drops the term), so leave the
		// box empty rather than show a search that is not applied. Never prefill the
		// product code either: submitting it would run the LIKE and return every
		// product whose code contains it, not the one on screen. Blank-checked the
		// same way api.py is, so a whitespace-only product does not hide a search the
		// server will still apply.
		if (typeof params.product === "string" && params.product.trim()) return;

		const search = params.search;
		// A repeated ?search= gives an array, not a string.
		if (typeof search !== "string" || !search) return;

		// Value only: get_query_filters() already fetched with this term, so
		// triggering input would fetch it again.
		this.searchBox.val(search);
	}

	// Search as you type, from 3 characters, once typing pauses for 300 ms. An
	// emptied box goes back to the default listing. 1-2 characters leave the
	// listing as it is.
	bindSearchAction() {
		this.searchBox.on("input", frappe.utils.debounce((e) => {
			// The box is rebuilt on every family click (prepare_search). A keystroke
			// still pending in a replaced box must not undo that click.
			if (!document.body.contains(e.target)) return;

			const query = e.target.value.trim();

			if (!query.length) {
				// Only when a search is on screen: emptying "ab" changes nothing.
				if (this.product_view.is_search_active()) {
					this.product_view.clear_search();
				}
				return;
			}

			if (query.length < 3) return;

			this.product_view.search(query);
		}, 300));
	}
};
